import React, { useState, useCallback } from 'react';
import { Input, Select, Button, Space, Row, Col, Card } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { PARTNER_STATUS, PARTNER_STATUS_LABELS } from '../../utils/constants';
import { debounce } from '../../utils/helpers';

const { Option } = Select;

const PartnerFilters = ({ filters, onFilterChange, onReset }) => {
  const [localSearch, setLocalSearch] = useState(filters.search || '');

  const debouncedSearch = useCallback(
    debounce((value) => {
      onFilterChange({ search: value });
    }, 500),
    [onFilterChange]
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setLocalSearch(value);
    debouncedSearch(value);
  };

  const handleStatusChange = (value) => {
    onFilterChange({ status: value });
  };

  const handleReset = () => {
    setLocalSearch('');
    onReset?.();
  };

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={24} md={12} lg={10}>
          <Input
            placeholder="Search by name, email, or phone"
            prefix={<SearchOutlined />}
            value={localSearch}
            onChange={handleSearchChange}
            allowClear
            aria-label="Search partners"
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={5}>
          <Select
            placeholder="Filter by status"
            value={filters.status || undefined}
            onChange={handleStatusChange}
            allowClear
            style={{ width: '100%' }}
            aria-label="Filter by status"
          >
            {Object.values(PARTNER_STATUS).map((status) => (
              <Option key={status} value={status}>
                {PARTNER_STATUS_LABELS[status]}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={6} lg={9}>
          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button icon={<ClearOutlined />} onClick={handleReset}>
              Clear Filters
            </Button>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default PartnerFilters;
